"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialog = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _DialogMixin = require("../../mixins/components/DialogMixin");
var StyledDialog = /*#__PURE__*/_styledComponents.default.section.withConfig({
  displayName: "StyledDialog",
  componentId: "c11n-8-107-0__sc-11wyxbm-0"
})(["", ""], _DialogMixin.DialogMixin);
exports.StyledDialog = StyledDialog;